require('./javascript');
require('./general');



// WEBPACK FOOTER //
// ./resources/assets/js/regular/index.js